import React, {useState} from 'react';
import {Result} from "../../client/Result";
import {CardSection} from "./Card";
import {UploadButton} from "./UploadButton";
import {uploadBucketMappingDataFormat, uploadDataFormat} from "../../Routes";
import {Col} from "react-bootstrap";
import {TextField} from "../OnboardingForm";
import {SelectField} from "./SelectField";
import {CustomerOption} from "../../client/OnboardingClient";
import {Organisation} from "../../client/UserClient";

interface UploadProps {
    onFileUpload: (file: File) => Promise<Result<null>>
    className?: string
}

export const UploadHalfHourlyConsumption: React.FC<UploadProps> = ({onFileUpload, className}) =>
    <CardSection className={className} header={'Upload Half Hourly Consumption'} data-testid={'fileUpload'} as="h6">
        <Col>
            <UploadButton onFileUpload={onFileUpload} formatPath={uploadDataFormat.path}
                          successMessage={"File accepted, now being processed. Updates will be sent to slack."}/>
        </Col>
    </CardSection>

interface UploadBucketMappingProps {
    onFileUpload: (file: File, bucketId: string) => Promise<Result<null>>
    className?: string
}

export const UploadBucketMapping: React.FC<UploadBucketMappingProps> = ({onFileUpload, className}) => {
    const [bucketId, setBucketId] = useState<string>()

    return <CardSection className={className} header={'Upload Capacity Market Bucket Mapping'}
                        data-testid={'bucketUpload'} as="h6">
        <Col>
            <TextField displayName={'BucketId'} name={'bucketId'} testId={'bucketId'}
                       handleChange={e => setBucketId(e.target.value)}/>
        </Col>
        <Col>
            <UploadButton onFileUpload={f => onFileUpload(f, bucketId!)}
                          disabled={bucketId === undefined || bucketId.length <= 3}
                          formatPath={uploadBucketMappingDataFormat.path}/>
        </Col>
    </CardSection>
}

interface ImportBuildingProps {
    customers: CustomerOption[]
    orgs: Organisation[]
    onFileUpload: (customerId: number, orgId: string | undefined, file: File) => Promise<Result<null>>
    className?: string
}

export const ImportBuilding: React.FC<ImportBuildingProps> = ({customers, orgs, onFileUpload, className}) => {
    const [customerId, setCustomerId] = useState<number>()
    const [orgId, setOrgId] = useState<string>()

    return <CardSection className={className} header={'Import Sites'}
                        data-testid={'importBuildings-fileUpload'}>
        <Col>
            <SelectField displayName={'Customer'} name={'customerId'} testId={'customerId'}
                         handleChange={(e) => setCustomerId(Number(e.target.value))} options={customers}
                         value={customerId}/>
        </Col>
        <Col>
            <SelectField displayName={'Org'} name={'orgId'} testId={'orgId'}
                         handleChange={(e) => setOrgId(e.target.value)} options={orgs} value={orgId}/>
        </Col>
        <Col>
            <UploadButton disabled={!customerId} onFileUpload={file => onFileUpload(customerId!, orgId, file)}
                          successMessage={"Buildings successfully imported."}/>
        </Col>
    </CardSection>
}
